module.exports = __webpack_public_path__ + "static/media/platinum3.fa10f998.svg";